module.exports = __webpack_public_path__ + "img/Loup garou.beb6561d.png";